import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { DexieInitializer } from '~/dexie/initializer';

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
  beforeLoad: async ({ context: { session } }) => {
    if (!session) {
      throw redirect({ to: '/login' })
    }
    return { session };
  },
})

function RouteComponent() {
  return (
    <DexieInitializer>
      <Outlet />
    </DexieInitializer>
  );
}
